﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconServerCog } from "@tabler/icons-react";


export const TiposDatosServiciosIcon = IconServerCog;
export const TiposDatosServiciosHelpText = '* Aquí puede ver la lista de todos los tipos de datos del servicio.';

export class catTiposDatosServicios extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposDatosServicios";
        this.def.columns.c_category_id.defaultValue = "TiposDatosServicios";
        this.Title = "Tipos de Datos de Servicio";
        this.HelpText = TiposDatosServiciosHelpText;
        this.Icon = TiposDatosServiciosIcon;
    }
}

